import Swal from "sweetalert2";

/**
 * Tema padrão VERT para todos os SweetAlert2 da plataforma.
 * Importar uma vez no bootstrap (App.js) para cobrir todos os `Swal.fire`.
 */

const BASE_CUSTOM_CLASS = {
  container: "swal2-vert-container",
  popup: "swal2-vert-popup",
  header: "swal2-vert-header",
  title: "swal2-vert-title",
  closeButton: "swal2-vert-close",
  icon: "swal2-vert-icon",
  image: "swal2-vert-image",
  htmlContainer: "swal2-vert-html",
  input: "swal2-vert-input",
  inputLabel: "swal2-vert-input-label",
  validationMessage: "swal2-vert-validation",
  actions: "swal2-vert-actions",
  confirmButton: "swal2-vert-confirm",
  denyButton: "swal2-vert-deny",
  cancelButton: "swal2-vert-cancel",
  footer: "swal2-vert-footer",
  timerProgressBar: "swal2-vert-timer",
};

function mergeCustomClass(base, extra) {
  if (!extra) return { ...base };
  const merged = { ...base };
  Object.entries(extra).forEach(([key, value]) => {
    if (!value) return;
    merged[key] = [base[key], value].filter(Boolean).join(" ");
  });
  return merged;
}

function normalizeOptions(args) {
  // Swal.fire(title) | Swal.fire(title, text) | Swal.fire(title, text, icon)
  if (typeof args[0] === "string" || args[0] instanceof HTMLElement) {
    const [title, text, icon] = args;
    return {
      title,
      text: typeof text === "string" ? text : undefined,
      icon: typeof icon === "string" ? icon : undefined,
    };
  }
  return { ...(args[0] || {}) };
}

const originalFire = Swal.fire.bind(Swal);

function buildOptions(raw, { forceLight = false } = {}) {
  const popupClass = forceLight
    ? "swal2-vert-popup swal2-vert-popup--light"
    : "swal2-vert-popup";
  const containerClass = forceLight
    ? "swal2-vert-container swal2-vert-container--light"
    : "swal2-vert-container";

  const baseClass = {
    ...BASE_CUSTOM_CLASS,
    popup: popupClass,
    container: containerClass,
  };

  const confirmColor = String(raw.confirmButtonColor || "var(--accent)");
  const isDangerConfirm =
    /danger|#c936|#ff6b|#e74c|#dc3545|vermelho/i.test(confirmColor);

  const userDidOpen = raw.didOpen;

  return {
    cancelButtonColor: "var(--surface-3)",
    denyButtonColor: "var(--danger)",
    ...raw,
    confirmButtonColor: isDangerConfirm ? "var(--danger)" : confirmColor,
    customClass: mergeCustomClass(baseClass, raw.customClass),
    didOpen: (popup) => {
      if (isDangerConfirm) {
        popup
          ?.querySelector(".swal2-confirm")
          ?.classList.add("swal2-vert-confirm--danger");
      }
      if (typeof userDidOpen === "function") userDidOpen(popup);
    },
  };
}

Swal.fire = (...args) => originalFire(buildOptions(normalizeOptions(args)));

/**
 * Modal SweetAlert forçado no tema light — use em telas públicas
 * (login, recover password, reset) fora do shell autenticado.
 */
export function firePublicSwal(...args) {
  return originalFire(
    buildOptions(normalizeOptions(args), { forceLight: true }),
  );
}

export default Swal;
